import menus from "../models/menus.json";
import { Link } from "react-router-dom";

const footerColumns = menus.flatMap((menu) => {
  if (menu.layout === "grouped") {
    return (menu.groups || []).map((group) => ({
      id: `${menu.id}-${group.title}`,
      title: group.title,
      items: group.items,
    }));
  }
  return [{ id: menu.id, title: menu.title, href: menu.href, items: menu.items || [] }];
});

const Footer = () => {
  return (
    <footer className="layout-shell flex w-full flex-col items-center gap-8 border-t border-slate-300 pb-10 pt-12 dark:border-slate-700 sm:gap-10 sm:pt-14">
      <div className="flex w-11/12 flex-col gap-8 lg:flex-row lg:justify-between lg:gap-10">
        <div className="flex max-w-sm flex-col gap-4">
          <Link to="/" className="flex items-center gap-3">
            <img src="/logo.webp" className="h-14 w-auto" alt="Hostzop Cloud logo" />
          </Link>
          <p className="text-sm leading-5 text-slate-600 dark:text-slate-400">
            Hostzop is a leading provider of cloud infrastructure services in India. We offer a range of services including compute, storage, and networking.
          </p>
          <div className="flex flex-col gap-2">
            <span className="text-sm text-slate-600 dark:text-slate-400"><b>Address: </b>Hostzop Cloud Services Pvt. Ltd, 3rd floor, Tass Mahal Complex, 3C, 10, Red Cross Rd, Egmore, Chennai, Tamil Nadu 600008</span>
            <span className="text-sm text-slate-600 dark:text-slate-400"><b>Email: </b><Link to="mailto:marketing@hostzop.com" target="_blank">marketing@hostzop.com</Link></span>
            <span className="text-sm text-slate-600 dark:text-slate-400"><b>Phone: </b><Link to="tel:1800 572 8782" target="_blank">1800 572 8782</Link></span>
          </div>
        </div>

        <div className="flex flex-1 flex-col gap-6 lg:items-end">
          <div className="grid w-full gap-6 sm:grid-cols-2 lg:grid-cols-4">
            {footerColumns.map((col) => (
              <div key={col.id} className="flex flex-col gap-3">
                <h4 className="text-sm font-semibold uppercase tracking-wide text-slate-900 dark:text-slate-100">{col.title}</h4>
                <div className="flex flex-col gap-2">
                  {col.href ? (
                    <Link
                      to={col.href}
                      className="text-sm text-slate-600 transition hover:text-brand-orange dark:text-slate-400 dark:hover:text-brand-orange"
                    >
                      {col.title}
                    </Link>
                  ) : (
                    (col.items || []).map((item) => (
                      <Link
                        key={item.label}
                        to={item.href}
                        className="text-sm text-slate-600 transition hover:text-brand-orange dark:text-slate-400 dark:hover:text-brand-orange"
                      >
                        {item.label}
                      </Link>
                    ))
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="flex w-11/12 flex-col gap-4 border-t border-slate-300 pt-5 text-sm text-slate-600 dark:border-slate-700 dark:text-slate-400 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex flex-wrap items-center gap-4 sm:gap-5">
          <Link to="/sitemap" className="transition hover:text-brand-orange">Sitemap</Link>
          <Link to="https://cloud.hostzop.com/app/" target="_blank" className="transition hover:text-brand-orange">Login</Link>
          <Link to="https://status.hostzop.com/" target="_blank" className="transition hover:text-brand-orange">Status</Link>
        </div>
        <p>© {new Date().getFullYear()} Hostzop Cloud. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;